import {RequiredRule, Validator} from 'devextreme-react/validator';
import {DateBox} from 'devextreme-react/date-box';
import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {AR, OrderStatus} from '../../../../types/enums';
import {formatDateWithTimeframe, TimeframeType} from '../../../../utils/date-utils';
import {WorkOrderContext} from '../context/WorkOrderContext';

export default function WorkCompleteDatePanel() {

	const { order, modifyOrder } = useContext(WorkOrderContext);

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled;

	let dateReadOnly = !order.details.activeARs.includes(AR.WOCfoToEnterWorkCompleteDate) || isOrderReadonly;
	let dateRequired = !dateReadOnly;

	return (
		<Panel header={'Dates'} >

			<Field label="Scheduled Install Date" >
				{formatDateWithTimeframe(order.details.scheduledDate, TimeframeType.Long)}
			</Field>
			<Field label="Work Complete Date" >
				<DateBox
					value={order.details.workCompleteDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, workCompleteDate: e.value })}
					readOnly={dateReadOnly || isOrderReadonly}
					className={dateRequired ? 'required' : ''}
					min={order.details.woDate}
					max={new Date()}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Work Complete Date is required'} />}
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
